export default __webpack_public_path__ + "static/media/TravelBackpack.c6992001.jpg";